import React, { Component } from 'react';
import { Button } from "reactstrap";
import { inject, observer } from 'mobx-react';
import ListaServicosAcessorios from './ListaServicosAcessorios';
import SimulacaoServicosAcessStore from '../stores/SimulacaoServicosAcessStore';
import { E_CONDICAO, E_TIPO_TELA } from '../stores/Enum';

@inject("store")
@observer
export default class AddServicosQtdVariavel extends Component {
    constructor(props) {
        super(props);

        this.tipoTela = this.props.tipoTela;

        switch (this.tipoTela) {
            case E_TIPO_TELA.Cabotagem:
                this.dataStore = this.props.controllers.cabStore;
                break;
            case E_TIPO_TELA.Importacao:
                this.dataStore = this.props.controllers.impStore;
                break;
            case E_TIPO_TELA.Exportacao:
                this.dataStore = this.props.controllers.expStore;
                break;
            case E_TIPO_TELA.Remocoes:
                this.dataStore = this.props.controllers.remStore;
                break;
            case E_TIPO_TELA.Transbordo:
                this.dataStore = this.props.controllers.traStore;
                break;
        }

        this.modalStore = this.props.store.modalStoreCustom;
        this.filterStore = this.props.controllers.filterStore;

        this.acessStore = new SimulacaoServicosAcessStore();
    }

    handleClickServicosAcessorios = async () => {
        const modalSelect = this.modalStore.openNewConfigurableModal('Atenção', {
            loading: true,
        });

        const requestBody = this.dataStore.buildRequestBody(this.filterStore.filters, E_CONDICAO.N_a);

        await this.acessStore.populateServicosAcessorios(requestBody, []);

        if (this.acessStore.servicosAcessorios.error) {
            modalSelect.appendConfigurableModal({
                body: <p dangerouslySetInnerHTML={{__html: this.acessStore.servicosAcessorios.error}}></p>,
                loading: false,
                hideCancel: true,
            });

            return;
        } 
        
        modalSelect.appendConfigurableModal({
            title: "Selecione os serviços",
            loading: false,
            className: "tamanho-modal-700",
            body: <ListaServicosAcessorios dataStore={this.acessStore} showQtd={true} />,
            okLabel: "LANÇAR",
            cancelLabel: "CANCELAR",
            onClickOk: saveAndClose.bind(this),
            resetOnSave: false,
        });

        async function saveAndClose() {               
            this.dataStore.addServicosAcessorios(this.acessStore.ServicosSelecionados);

            if (this.acessStore.servicosAcessorios.error) {
                this.modalStore.openNewConfigurableModal('Alerta!', {
                    body: <p>{this.acessStore.servicosAcessorios.error}</p>,
                    hideCancel: true,
                });
                return;
            }
            else {
                modalSelect.destroy();
            }
        }
    }

    render() {
        const { disabled } = this.props;
        return (
            <Button 
                outline
                className="mb-1 btn-com-bordas-primary"
                onClick={() => this.handleClickServicosAcessorios()} 
                disabled={disabled}
            > 
                + Serviços Qtd. Variável
            </Button>
        )
    }
}


// WEBPACK FOOTER //
// ./src/modules/simulacao-servicos/components/AddServicosQtdVariavel.js